import { useState } from "react";
import {Card, Flex} from 'antd';
const NewsPage = (props) => {
    const [news, updateNews] = useState([{
        title: "2025-08-15",
        description: "Создан этот сайт"
    }]);
    return (
        <Flex align="top" justify="center" gap="1em">
            {news.map(n => (<Card title={n.title}><Card.Meta description={n.description}/></Card>))}
        </Flex>
    )
}
export default NewsPage;